import styled from '@emotion/styled';
export const StyledForm = styled.form `
  height: 100%;
`;
//# sourceMappingURL=DrawerContent.styled.js.map